/* ADDED 2024.06.17 RBN MENU EXTERNAL LINKS OPEN IN NEW WINDOW */
var links = document.links;
for (let i = 0, linksLength = links.length ; i < linksLength ; i++) {
  if (links[i].hostname !== window.location.hostname) {
    links[i].target = '_blank';
    links[i].rel = 'noreferrer noopener';
  }
};


/* ADDED 2024.06.26 RBN CONSOLIDATED SCRIPT */
var time = parseInt(new Date().getTime());
localStorage.setItem("ba_msg_active", time);


/* ADDED 2024.07.04 RBN BING WEBMASTER INDEXNOW */
function integrateIndexNow(shopifyToken, shopifyStoreName, indexNowUrl) {
  return new Promise((resolve, reject) => {

// Create a Shopify webhook to trigger the indexing process
    const shopifyWebhook = {
      webhook: {
        topic: 'products/update',
        address: indexNowUrl,
        format: 'json',
      },
    };

// Make a POST request to the Shopify API to create the webhook
//    fetch(`https://${shopifyApiKey}:${shopifyApiSecret}@${shopifyStoreName}.myshopify.com/admin/api/2024-01/webhooks.json`, {
      fetch(`https://${shopifyStoreName}.myshopify.com/admin/api/2024-01/webhooks.json`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Authorization': 'Basic ${shopifyToken}',
        'Access-Control-Allow-Origin': '*',
      },
      body: JSON.stringify(shopifyWebhook),
    })
      .then((response) => {
        if (response.ok) {
          resolve();
        } else {
          reject(new Error('Failed to create webhook'));
        }
      })
      .catch((error) => {
        reject(error);
      });
  });
}

// USEAGE
const shopifyStoreName = 'gym-in-the-box';
const shopifyApiKey    = 'fce43f3ab709531ab5d74d324a70ace9';
const shopifyApiSecret = '6a92fc5df4a0e45b5b7d2c4b100288f0';
const token            = shopifyApiKey + ":" + shopifyApiSecret;
const shopifyToken     = btoa(token); 
const indexNowUrl      = 'https://indexnow.com/webhook';
/*
integrateIndexNow(shopifyToken, shopifyStoreName, indexNowUrl)
  .then(() => {
    console.log('Webhook created successfully');
  })
  .catch((error) => {
    console.error('Failed to create webhook:', error);
  });
*/



/* ADDED 2026.06.26 RBN - GOOGLE ANALYTICS GTAG */
/* Initialize JavaScript Pixel SDK */
/*
const script = document.createElement('script');
script.setAttribute('src', 'https://www.googletagmanager.com/gtag/js?id=YOUR_PIXEL_ID');
script.setAttribute('async', '');
document.head.appendChild(script);

window.dataLayer = window.dataLayer || [];
function gtag(){dataLayer.push(arguments);}
gtag('js', new Date());
gtag('config', 'G-FTZTLXL1GM');
*/

/* Subscribe To Customer Events */
/*
analytics.subscribe("special_email_signup", event => {
  window.dataLayer.push({event: emailSignUp, emailCampaignId: event.customData.email_campaign_id});
});
*/
/* Configure Consent */
/*
gtag('consent', 'update', {
  'ad_storage': 'granted',
  'analytics_storage': 'granted',
  'ad_user_data': 'granted',
  'ad_personalization': 'granted',
});
*/


/*
if ( first_time_accessed )
  {
  dataLayer.push({
  event: "purchase",
  ecommerce: {
      transaction_id: "{{ order.order_number }}",
      value: {{ total_price | times: 0.01 }},
      tax: {{ tax_price | times: 0.01 }},
      shipping: {{ shipping_price | times: 0.01 }},
      currency: "{{ order.currency }}",
      items: [
      foreach( line_item as line_items )
        {
        item_id = line_item.product_id,
        item_name = "{{ line_item.title | remove: "'" | remove: '"' }}",
        currency = "{{ order.currency }}",
        price = {{ line_item.final_price | times: 0.01 }},
        quantity = {{ line_item.quantity }}
        }, 
        ]
      }
    });

  }; // end - if
*/

/*
(function(w,d,s,l,i){w[l]=w[l]||[];w[l].push({'gtm.start':
  new Date().getTime(),event:'gtm.js'});var f=d.getElementsByTagName(s)[0],
  j=d.createElement(s),dl=l!='dataLayer'?'&l='+l:'';j.async=true;j.src=
  'https://www.googletagmanager.com/gtm.js?id='+i+dl;f.parentNode.insertBefore(j,f);
  })(window,document,'script','dataLayer','G-FTZTLXL1GM');
*/



/* ADDED 2024.07.06 RBN CHECK GOOGLE ANAYTICS LOADED */
/*
function checkGoogleAnalyticsLoaded() {
  if (window._gaq && window._gaq._getTracker) {
    // Do tracking with new-style analytics
    console.log('Loaded: '+ gaq);
    alert('Google Analytics is Loaded :'+ gaq);
  } else if (window.urchinTracker) {
    // Do tracking with old-style analytics
    console.log('Loaded: '+ gaq);
    alert('Google Analytics is Loaded :'+ gaq);
  } else {
    // Retrey Lading Analytics
    alert('Google Analytics is Not Loaded:');
    setTimeout(checkGoogleAnalyticsLoaded, 500);
  }
}
// checkGoogleAnalyticsLoaded();
*/

/* AFTERPAY */
/*
window.onload = function() {
  if ( window.jQuery ) { 
    $( document ).ready(function() {
//      alert( "ready!" );
      let element = document.querySelector( '.afterpay-logo-link' );
      $( element ).css( 'min-width', '24px !important' );
      $( element ).css( 'min-height', '24px !important' );
      element = JSON.stringify( $( element ) );
      alert( element );
      
      element = document.querySelector( '.product-single__review-link' );
      $( element.parent ).attr( 'aria-label', 'Afterpay Review' );
      });
};
};
*/


/* AFTERPAY */
/*
window.onload = function() {
  if ( window.jQuery ) { 
    $( document ).ready(function() {
//      alert( "ready!" );
      let element = document.querySelector( '.afterpay-logo-link' );
      $( element ).css( 'min-width', '24px !important' );
      $( element ).css( 'min-height', '24px !important' );
      element = JSON.stringify( $( element ) );
      alert( element );
      
      element = document.querySelector( '.product-single__review-link' );
      $( element.parent ).attr( 'aria-label', 'Afterpay Review' );
      });
};
};
*/


